<template>
  <v-btn
    color="error"
    block
    class="mt-4"
    @click="handleLogout"
  >
    Logout
  </v-btn>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'UserLogout',
  methods: {
    ...mapActions(['logout']),
    handleLogout() {
      this.logout();
      this.$router.push('/login');
    },
  },
};
</script>
